import styled from 'styled-components'

export const ExpenseDetailViewStyled = styled.div<{
  showSpendTracker: boolean
}>`
  display: grid;
  gap: ${(p) => p.theme.space.large};
  align-items: start;

  ${(p) =>
    p.showSpendTracker
      ? `
    grid-template-columns: 1fr auto;
    grid-template-areas: 'main-content spend-tracker';
    @media (max-width: 1192px) {
      grid-template-columns: auto;
      grid-template-areas:
        'main-content'
        'spend-tracker';
    }
  `
      : `
    grid-template-columns: auto;
    grid-template-areas: 'main-content';
  `}
`

export const MainContentStyled = styled.div`
  grid-area: main-content;
`

export const SpendTrackerSidebarStyled = styled.div<{
  showSpendTracker: boolean
}>`
  grid-area: spend-tracker;
  position: sticky;
  top: 5.5rem;
  min-width: 25rem;
  display: ${(p) => (p.showSpendTracker ? 'block' : 'none')};
`
